import {HTTP} from "@/http";

class EntraGroupServiceClass {
  basePath = 'api/v2/entra-groups';

  /**
   * Get all Entra groups for a given connection.
   * @param {string} connectionId
   * @returns {Promise<Object>}
   */
  getByConnection(connectionId) {
    return HTTP.get(this.basePath, {params: {connectionId}});
  }

  /**
   * Trigger a group synchronization for a given connection.
   * @param {string} connectionId
   * @returns {Promise<Object>}
   */
  syncConnection(connectionId) {
    return HTTP.post(`${this.basePath}/sync/connections/${connectionId}`);
  }
}

/**
 * @type {EntraGroupServiceClass}
 */
export const entraGroupService = new EntraGroupServiceClass();
